import IToolConfig from "@/types/IToolConfig";
import { TEXT_SELECTORS } from "@/enum/Selectors";
import { injectToolCSS } from "@/utils/cssGenerator";

export type TextAlignValue = "left" | "right" | "center" | false;

export default function textAlign(value: TextAlignValue) {
    const direction: "left" | "right" | "center" = value || "left";
    const config: IToolConfig = {
        id: "text-align",
        selector: `html`,
        childrenSelector: TEXT_SELECTORS,
        styles: {
            "text-align": direction,
        },
    };
    injectToolCSS({
        ...config,
        enable: !!value,
    });
}
